import { render, staticRenderFns } from "./CloHeaderIdentity.vue?vue&type=template&id=1a8cb750&"
import script from "./CloHeaderIdentity.vue?vue&type=script&lang=js&"
export * from "./CloHeaderIdentity.vue?vue&type=script&lang=js&"
import style0 from "./CloHeaderIdentity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports